"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _reactIconBase = _interopRequireDefault(require("react-icon-base"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

var CategoryCodePOLR = function CategoryCodePOLR(props) {
  return _react.default.createElement(_reactIconBase.default, _extends({
    viewBox: "0 0 16 16"
  }, props), _react.default.createElement("g", null, _react.default.createElement("title", null, "CategoryCodePOLR"), _react.default.createElement("path", {
    d: "M13.329,7.056a.868.868,0,0,0,.647-1.041.869.869,0,0,0-1.039-.653L12.35,2.821a.88.88,0,0,0-1.038-.652A9.559,9.559,0,0,1,6,6.073l-3.16.73a1.037,1.037,0,0,0-.672.483,1.049,1.049,0,0,0-.137.82l.294,1.27a1.049,1.049,0,0,0,.482.676,1.037,1.037,0,0,0,.816.139s.42-.083.977-.2l1.49,3.213a.837.837,0,0,0,1,.625l.695-.16a.838.838,0,0,0,.625-1l-1.3-3.232a1.27,1.27,0,0,0,.233-.078,10.014,10.014,0,0,1,5.928,1.279A.881.881,0,0,0,13.916,9.6ZM7.44,8.466,7.027,6.679a10.492,10.492,0,0,0,4.532-3.438l1.459,6.313A10.523,10.523,0,0,0,7.44,8.466Z"
  })));
};

var _default = CategoryCodePOLR;
exports.default = _default;